<template>
  <ModalStructure @close="$emit('close')" :nopadding="true" style="min-height: 400px">
    <div slot="title">
      <v-icon small left>mdi-cog</v-icon>Configure Form
    </div>
    <div slot="body">
      <v-tabs vertical>
        <v-tab style="justify-content: flex-start">
          <v-icon left>mdi-account</v-icon>Integrations
        </v-tab>
        <v-tab style="justify-content: flex-start">
          <v-icon left>mdi-account</v-icon>Auto Responding
        </v-tab>
        <v-tab style="justify-content: flex-start">
          <v-icon left>mdi-account</v-icon>Form Submit Event
        </v-tab>
        <v-tab-item class="pa-2">
          <FormConfigurationIntegrations :block="block"></FormConfigurationIntegrations>
        </v-tab-item>
        <v-tab-item class="pa-2">
          <div class="title">Auto responding</div>
          <v-alert dense text border="left" type="warning">
            You can response to form requests automatically.
            In order to send an auto responding e-mail, your form must contain one
            <u>e-mail</u> input
          </v-alert>
          <v-switch
            v-model="block.config.notificationConfig.autoResponding.enabled"
            label="Enable auto responding"
            @change="onInputChange($event ? true : false, ['config', 'notificationConfig', 'autoResponding', 'enabled'])"
            dense
            flat
            inset
          ></v-switch>
          <v-text-field
            :value="block.config.notificationConfig.autoResponding.subject"
            outlined
            dense
            label="Subject"
            autocomplete="off"
            type="text"
            @change="onInputChange($event, ['config', 'notificationConfig', 'autoResponding', 'subject'])"
            :disabled="!block.config.notificationConfig.autoResponding.enabled"
          ></v-text-field>
          <v-text-field
            :value="block.config.notificationConfig.autoResponding.senderEmail"
            outlined
            dense
            label="Sender E-mail"
            autocomplete="off"
            type="email"
            @change="onInputChange($event, ['config', 'notificationConfig', 'autoResponding', 'senderEmail'])"
            :disabled="!block.config.notificationConfig.autoResponding.enabled"
          ></v-text-field>
          <v-textarea
            :value="block.config.notificationConfig.autoResponding.content"
            outlined
            dense
            label="Content"
            autocomplete="off"
            type="text"
            @change="onInputChange($event, ['config', 'notificationConfig', 'autoResponding', 'content'])"
            :disabled="!block.config.notificationConfig.autoResponding.enabled"
          ></v-textarea>
          <v-alert
            dense
            text
            border="left"
            type="info"
          >You can test this configuration in your live site.</v-alert>
        </v-tab-item>
        <v-tab-item class="pa-2">
          <div class="title">Auto responding</div>
          <v-alert dense text border="left" type="info">
            You can execute a custom script when submit button is clicked. This event will be called after the form is submitted correctly. Some script examples:
            <br />
            <br />
            <pre>alert('Thanks for submitting!');</pre>
            <pre>// or send event to Google Analytics</pre>
            <pre>ga('send', 'event', 'Videos', 'play', 'Fall Campaign');</pre>
          </v-alert>
          <v-switch
            v-model="block.config.notificationConfig.executeScriptOnSubmit.executeScript"
            label="Enable script executing on button submit"
            @change="onInputChange($event ? true : false, ['config', 'notificationConfig', 'executeScriptOnSubmit', 'executeScript'])"
            dense
            flat
            inset
          ></v-switch>
          <v-textarea
            :value="block.config.notificationConfig.executeScriptOnSubmit.script"
            outlined
            dense
            label="Content"
            autocomplete="off"
            type="text"
            @change="onInputChange($event, ['config', 'notificationConfig', 'executeScriptOnSubmit', 'script'])"
            :disabled="!block.config.notificationConfig.executeScriptOnSubmit.executeScript"
          ></v-textarea>
          <v-alert
            dense
            text
            border="left"
            type="info"
          >You can test this configuration in your live site.</v-alert>
        </v-tab-item>
      </v-tabs>
    </div>
  </ModalStructure>
</template>

<script>
import projectMixin from "../project-mixin";
import FormConfigurationIntegrations from "./FormConfigurationIntegrations";

export default {
  mixins: [projectMixin],
  components: { FormConfigurationIntegrations },
  props: ["block"],
  methods: {
    onInputChange(value, prop) {
      this.UPDATE_BLOCK_PROP({ id: this.block.id, prop, value });
    }
  }
};
</script>